const govButtons = ["Councillor", "Group", "Council", "Department"];

export default govButtons;



// WEBPACK FOOTER //
// ./src/content/Home-GovButtons.js